/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import AttachMoney from '@material-ui/icons/AttachMoney';
import CreditCard from '@material-ui/icons/CreditCard';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import Grid from '@material-ui/core/Grid';
import { Box } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import { useSnackbar } from 'notistack';
import MaskService from 'react-masked-text/src/mask-service';
import { MoneyMask } from 'react-masked-text/src/masks/money.mask';
import { formatPrice } from '../../../utils/format';
import useStyles from './styles';

function Payment() {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const dispatch = useDispatch();

  const stepDefault = 0;
  const paymentValueDefault = { value: '0,00' };
  const [step, setStep] = useState(stepDefault);
  const [paymentValue, setPaymentValue] = useState(paymentValueDefault);
  const [modalQuestionPaymentAmount, setModalQuestionPaymentAmount] = useState(
    false
  );

  const { payments } = useSelector(state => state.data);
  const { modality, payment } = useSelector(state => state.order.order);
  const { formattedTotal, total } = useSelector(state => {
    const { order } = state.order;

    return {
      total: order.total,
      formattedTotal: formatPrice(order.total),
    };
  });

  useEffect(() => {
    if (payment && payment.cod === 1 && payment.value === 0) {
      setModalQuestionPaymentAmount(true);
    }
  }, [payment]);

  const handleChange = event => {
    setStep(stepDefault);
    setPaymentValue(paymentValueDefault);

    const value = Number(event.target.value);
    const { payment_id, cod } = payments.find(p => p.cod === value);
    dispatch({
      type: '@order/PAYMENT',
      payment: {
        payment_id,
        cod,
        value: cod === 1 ? 0 : total,
        formattedValue: formatPrice(cod === 1 ? 0 : total),
      },
    });
  };

  const handleNotValue = () => {
    setModalQuestionPaymentAmount(false);
    dispatch({
      type: '@order/PAYMENT',
      payment: {
        ...payment,
        value: total,
        formattedValue: formatPrice(total),
      },
    });
  };

  const handleConfirmValue = () => {
    const moneyMaskFormatting = new MoneyMask();
    const value = moneyMaskFormatting.getRawValue(paymentValue.value);
    if (value <= total) {
      enqueueSnackbar(
        `Você deve pedir troco para um valor maior do que ${formattedTotal}`,
        { variant: 'error' }
      );

      setPaymentValue({
        value: paymentValue.value,
        error: true,
      });
      return;
    }

    setModalQuestionPaymentAmount(false);

    dispatch({
      type: '@order/PAYMENT',
      payment: {
        ...payment,
        value,
        formattedValue: formatPrice(value),
      },
    });
  };

  return modality <= 1 ? (
    <>
      <div className={classes.root}>
        <span className={classes.title}>Pagamento</span>
        <ul className={classes.body}>
          {payments.map(item => (
            <li key={item.cod} className={classes.item}>
              {item.cod === 1 && <AttachMoney size={24} />}
              {item.cod === 3 && <CreditCard size={24} />}
              {item.cod === 5 && <WhatsAppIcon size={24} />}

              <div className={classes.name}>
                {item.cod === 1 && <span>dinheiro</span>}
                {item.cod === 3 && <span>cartão</span>}
                {item.cod === 5 && <span>WhatsApp</span>}

                {item.cod === 1 && payment.value > total ? (
                  <span className={classes.change}>
                    {`troco para ${payment.formattedValue}`}
                  </span>
                ) : null}
              </div>

              <Radio
                checked={item.cod === payment.cod}
                onChange={handleChange}
                value={item.cod}
                color="default"
                name="payment"
              />
            </li>
          ))}
        </ul>
      </div>

      <Drawer anchor="bottom" open={modalQuestionPaymentAmount}>
        {step === 0 && (
          <Box p={2}>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <Box p={2}>
                  <Typography variant="h6">Dinheiro</Typography>
                </Box>
              </Grid>
              <Grid item>
                <Typography>Você vai precisar de troco?</Typography>
              </Grid>
            </Grid>
            <Box p={2}>
              <Grid container>
                <Grid item xs>
                  <Box p={1}>
                    <Button
                      className={classes.ButtonTroco}
                      variant="contained"
                      color="secondary"
                      fullWidth
                      onClick={handleNotValue}
                    >
                      <Typography>Não</Typography>
                    </Button>
                  </Box>
                </Grid>
                <Grid item xs>
                  <Box p={1}>
                    <Button
                      className={classes.ButtonTroco}
                      variant="contained"
                      color="secondary"
                      fullWidth
                      onClick={() => setStep(1)}
                    >
                      <Typography>Sim</Typography>
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}

        {step === 1 && (
          <Box p={2}>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <Box p={2}>
                  <Typography variant="h6">Troco para quanto?</Typography>
                </Box>
              </Grid>
              <Grid item>
                <Typography>{`Seu pedido deu ${formattedTotal}. Digite quanto vai pagar em dinheiro para que o entregador leve o seu troco.`}</Typography>
              </Grid>
              <Grid item>
                <Box p={2}>
                  <TextField
                    error={paymentValue.error}
                    id="payment-value"
                    InputProps={{
                      fullWidth: true,
                      startAdornment: (
                        <InputAdornment position="start">R$</InputAdornment>
                      ),
                    }}
                    autoFocus
                    value={paymentValue.value}
                    onChange={event => {
                      const money = MaskService.toMask(
                        'money',
                        event.target.value,
                        {
                          unit: '',
                          separator: ',',
                          delimiter: '.',
                        }
                      );
                      setPaymentValue({ value: money });
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
            <Box p={2}>
              <Grid container>
                <Grid item xs>
                  <Box p={1}>
                    <Button
                      className={classes.ButtonTroco}
                      variant="contained"
                      color="secondary"
                      fullWidth
                      onClick={handleNotValue}
                    >
                      <Typography>cancelar</Typography>
                    </Button>
                  </Box>
                </Grid>
                <Grid item xs>
                  <Box p={1}>
                    <Button
                      className={classes.ButtonTroco}
                      variant="contained"
                      color="secondary"
                      fullWidth
                      onClick={handleConfirmValue}
                    >
                      <Typography>confirmar</Typography>
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}
      </Drawer>
    </>
  ) : null;
}

export default Payment;
